import { post, put } from 'utils/methods';

export function addCostApi(data, headers) {
    return post(`${process.env.REACT_APP_REST}commands/cost-and-duration`, data, headers);
}

export function editCostApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/cost-and-duration`, data, headers);
}

export function toggleCostStatusApi(data, headers) {
    return put(`${process.env.REACT_APP_REST}commands/cost-and-duration/status`, data, headers);
}
